<form novalidate #motorsClassifiedPricingSectionForm="ngForm">
    <tg-row *ngIf="draftLoaded$ | async" class="motors-listing-details-page__section">
        <tg-col sm="12" lg="8">
            <tg-row>
                <tg-col sm="12" lg="6">
                    <tg-input-container label="What's your asking price?">
                        <span class="
                                motors-classified-pricing-section__currency-symbol
                            ">$</span>
                        <input tgTextInput wholeNumber name="askingPrice" required (blur)="publish()"
                            [(ngModel)]="draftData.listingDetails.askingPrice" [validation]="
                                validation.listingDetails.askingPrice | toValidator
                            " />
                    </tg-input-container>
                </tg-col>
                <tg-col sm="12" lg="6">
                    <tg-checkbox name="orNearOffer" [(ngModel)]="
                            draftData.listingDetails
                                .orNearOffer
                        " class="motors-classified-pricing-section__or-near-offer__checkbox" (change)="publish()">
                        <tg-label>Or near offer</tg-label>
                    </tg-checkbox>
                </tg-col>
            </tg-row>
            <tg-row *ngIf="_feeCalculationFacade.isIncreasePricingTier$ | async">
                <tg-col md="8" sm="12">
                    <tg-info-box>
                        Your listing fee will be updated according to the new listing price
                    </tg-info-box>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
